angular
	.module('main')
	.controller('ConfirmSignUpController', ConfirmSignUpController);

ConfirmSignUpController.$inject = [
	'$scope',
	'$rootScope',
	'$location',
	'accountDataService',
	'messageService'
];

function ConfirmSignUpController(
	$scope,
	$rootScope,
	$location,
	accountDataService,
	messageService
) {
	$scope.$on('$viewContentLoaded', () => {
		$rootScope.signInPage = false;
		const url = $location.path();

		accountDataService
			.confirmSignUp(url)
			.subscribe(
				data => successConfirmSignUp(data),
				error => errorConfirmSignUp(error)
			);
	});

	function successConfirmSignUp(data) {
		if (data) {
			if (data.success) {
				delete $rootScope.error;
				messageService.showToaster('s_1', 'login');
				$location.path('/login');
			} else {
				messageService.showToaster('e_5', 'login');
				$rootScope.error = true;
				$rootScope.error_message = data.message;
			}
			$scope.userActionResult = data;
		}
	}

	function errorConfirmSignUp() {
		messageService.showToaster('e_0', 'general');
		$rootScope.authenticated = false;
		$rootScope.error = true;
		$rootScope.error_message = 'Failed request to server';
	}
}



// WEBPACK FOOTER //
// ./web/js/controllers/login/confirmSignUpController.js